import React, { useMemo } from 'react';
import { useAppSelector } from '@web-common/state/createStore';
import { isMailListDiff } from '@web-mail/utils/mailCompare';
import MailListMenuMultConfig from '@web-mail/common/components/MailMenu/mailMenuConifg/MailListMenuMultConfig';
import MailListMenuMultConfig2AllFolder from '@web-mail/common/components/MailMenu/mailMenuConifg/MailListMenuMultConfig2AllFolder';
import MailMenuBase from '@web-mail/common/components/MailMenu/MailMenuBase/MailMenuBase';
const defaultArray = [];
const MailMenuMult = props => {
    const { activeMailId, setVisible, domProps, moreAccounts = false } = props;
    const checkedMails = useAppSelector(state => {
        var _a;
        if ((_a = state === null || state === void 0 ? void 0 : state.mailReducer) === null || _a === void 0 ? void 0 : _a.mailEntities) {
            const mailList = [];
            activeMailId.forEach(id => {
                var _a;
                mailList.push((_a = state === null || state === void 0 ? void 0 : state.mailReducer) === null || _a === void 0 ? void 0 : _a.mailEntities[id]);
            });
            return mailList;
        }
    }, (old, newValue) => {
        return !isMailListDiff(old, newValue);
    }) || defaultArray;
    const _moreAccounts = useMemo(() => {
        if (checkedMails && checkedMails.length > 0) {
            const accountIds = checkedMails.map(mail => mail._account);
            const firstAccountId = accountIds[0];
            return !accountIds.every(accountId => accountId === firstAccountId) || moreAccounts;
        }
        return moreAccounts;
    }, [checkedMails, moreAccounts]);
    return (React.createElement(MailMenuBase, { mail: checkedMails, onMenuClick: () => {
            setVisible(false);
        }, defaultMenu: _moreAccounts ? MailListMenuMultConfig2AllFolder : MailListMenuMultConfig, domProps: domProps }));
};
export default MailMenuMult;
